import {
    ADD_APP_VERSION,
    CLEAR_CREATE_APP_VERSION_ERROR,
    CLEAR_UPDATE_APP_VERSION_ERROR,
    CLOSE_CREATE_APP_VERSION_MODAL,
    CLOSE_UPDATE_APP_VERSION_MODAL,
    CREATE_APP_VERSION_ERROR,
    CREATE_APP_VERSION_PENDING,
    GET_APP_VERSION_PENDING,
    OPEN_CREATE_APP_VERSION_MODAL,
    OPEN_UPDATE_APP_VERSION_MODAL,
    APP_VERSION_LIST_ERROR,
    SET_APP_VERSION_LIST,
    SET_APP_VERSION_DETAILS,
    UPDATE_APP_VERSION_ERROR,
    UPDATE_APP_VERSION_PENDING,
    CLEAR_APP_VERSION_LIST_ERROR,
    SET_APP_VERSION_EDIT_FORM
} from "./constants";

const initialState = {
    //--------------------------------APP-VERSION-LIST------------------------------------------------
    isAppVersionListPending: false,
    appVersionList: [],
    totalRecords: null,
    appVersionListError: null,
    //--------------------------------APP-VERSION-CREATE----------------------------------------------
    isAppVersionCreateModalOpen: false,
    isAppVersionCreatePending: false,
    addAppVersionForm: {},
    appVersionCreateErrorMessage: null,
    //--------------------------------APP-VERSION-EDIT------------------------------------------------
    appVersionetails: {},
    appVersionEditForm: {},
    isAppVersionEditModalOpen: false,
    isAppVersionEditPending: false,
    appVersionEditErrorMessage: null,

};

export default (localState = initialState, action) => {
    switch (action.type) {
        //--------------------------------APP-VERSION-LIST------------------------------------------------
        case GET_APP_VERSION_PENDING: {
            return {
                ...localState,
                isAppVersionListPending: true,
            };
        }

        case SET_APP_VERSION_LIST: {
            const { appVersionOdata } = action.payload;
            return {
                ...localState,
                isAppVersionListPending: false,
                appVersionListError: null,
                appVersionList: appVersionOdata && appVersionOdata.value,
                totalRecords: appVersionOdata && appVersionOdata['@odata.count'],
            };
        }

        case APP_VERSION_LIST_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                appVersionListError: errorMessage,
                isAppVersionListPending: false,
                appVersionList: [],
                totalRecords: 0
            };
        }

        case CLEAR_APP_VERSION_LIST_ERROR: {
            return {
                ...localState,
                appVersionListError: null,
                isAppVersionListPending: false,
            };
        }

        //--------------------------------APP-VERSION-CREATE----------------------------------------------
        case OPEN_CREATE_APP_VERSION_MODAL: {
            return {
                ...localState,
                isAppVersionCreateModalOpen: true,
                appVersionCreateErrorMessage: null,
            };
        }

        case CLOSE_CREATE_APP_VERSION_MODAL: {
            return {
                ...localState,
                isAppVersionCreateModalOpen: false,
            };
        }
        case ADD_APP_VERSION: {
            const { addAppVersionForm } = action.payload;
            return {
                ...localState,
                addAppVersionForm: addAppVersionForm
            };
        }

        case CREATE_APP_VERSION_PENDING: {
            return {
                ...localState,
                isAppVersionCreatePending: true,
            };
        }

        case CREATE_APP_VERSION_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                appVersionCreateErrorMessage: errorMessage,
                isAppVersionCreatePending: false,
            };
        }

        case CLEAR_CREATE_APP_VERSION_ERROR: {
            return {
                ...localState,
                isAppVersionCreatePending: false,
                appVersionCreateErrorMessage: null,
            };
        }

        //--------------------------------APP-VERSION-EDIT------------------------------------------------
        case SET_APP_VERSION_DETAILS: {
            const { appVersionDetails } = action.payload;
            return {
                ...localState,
                appVersionetails: appVersionDetails
            }
        }
        case OPEN_UPDATE_APP_VERSION_MODAL: {
            return {
                ...localState,
                isAppVersionEditModalOpen: true,
                appVersionCreateErrorMessage: null,
            };
        }

        case CLOSE_UPDATE_APP_VERSION_MODAL: {
            return {
                ...localState,
                isAppVersionEditModalOpen: false,
            };
        }

        case SET_APP_VERSION_EDIT_FORM: {
            const { appVersionForm } = action.payload;
            return {
                ...localState,
                appVersionEditForm: appVersionForm
            }
        }

        case UPDATE_APP_VERSION_PENDING: {
            return {
                ...localState,
                isAppVersionEditPending: true,
            };
        }

        case UPDATE_APP_VERSION_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                appVersionEditErrorMessage: errorMessage,
                isAppVersionEditPending: false,
            };
        }

        case CLEAR_UPDATE_APP_VERSION_ERROR: {
            return {
                ...localState,
                isAppVersionEditPending: false,
                appVersionEditErrorMessage: null,
            };
        }

        default: {
            return localState;
        }
    }
};
